import { Component } from '@angular/core';

@Component({
  selector: 'app-membership-list',
  imports: [],
  templateUrl: './membership-list.component.html',
  styleUrl: './membership-list.component.scss'
})
export class MembershipListComponent {

}
